import React from 'react'
import { ShowCaseDiv } from './style'
import hero from '../../../assets/images/hero.jpg'

function ShowCase() {
    return (
        <ShowCaseDiv style={{ backgroundImage: `url(${hero})` }}>
            <div className="inner-container">
                <div className="banner pt-5" >
                        <div className="yourhealthbox">
                            <h2><span className="your">Your</span> <span className="health">Health</span><br/>
                        <span className="our">Our</span> <span className="priority">Priority</span><span className="your">.</span>
                            </h2>
                            <button>Get Started</button>
                        </div>
                    </div>
            </div>
            
        </ShowCaseDiv>
    )
}

export default ShowCase
